"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupAudioActivity = setupAudioActivity;
exports.default = void 0;

var _content = babelHelpers.interopRequireDefault(require("./content"));

var _default = _content.default;
exports.default = _default;

function setupAudioActivity(activity, _ref) {
  var messageServer = _ref.messageServer,
      customerKey = _ref.customerKey,
      app = _ref.app,
      object = _ref.object,
      sessionID = _ref.sessionID;
  var currentPosition = 0;
  var prevPosition = 0;
  var serverPosition = NaN;
  var clientPosition = NaN;
  var player = $('#audio-player').data('player');
  var o = player.options;
  var audioLength = o.audioDuration;
  var clientPosition;
  if (o.audioPlaybackFinished) clientPosition = 0;else if ('startPosition' in o) clientPosition = o.startPosition;
  var start = Date.now(),
      trackTimeout = null;
  var eventListener = new EventSourceImpl("".concat(messageServer, "/").concat(customerKey, "/hls-").concat(sessionID, "-").concat(app, "-").concat(object));
  var didEndActivity = false;
  var handlePlay = true;

  try {
    eventListener.onmessage = handleMessage;
    eventListener.start();
  } catch (e) {
    debugger;
  }

  activity.on('unload', unload);
  player.on('timeupdate', timeupdate);
  player.on('play', play);
  player.on('pause', pause);
  player.on('stop', pause);
  activity.stopTimer();

  function pause() {
    try {
      var e = $('#audio-player').find('audio, video')[0];
      clientPosition = e.currentTime;
      updatePosition();
      if (!e.ended) handlePlay = true;
    } catch (e) {}
  }

  function play() {
    if (handlePlay && clientPosition !== 0) {
      try {
        $('#audio-player').find('audio, video')[0].currentTime = clientPosition;
        handlePlay = false;
      } catch (e) {}
    }
  }

  function timeupdate(event) {
    if (event.current === event.total && event.current === 1) {
      try {
        var e = $('#audio-player').find('audio, video')[0].currentTime;
        clientPosition = Math.max(clientPosition, e);
      } catch (unused) {}
    } else {
      clientPosition = Math.max(clientPosition, event.current);
    }

    updatePosition();
  }

  function unload() {
    eventListener.close();
  }

  function handleMessage(event) {
    if (event.type == 'progress') {
      var d = JSON.parse(event.data);
      serverPosition = d.progress.position;
      updatePosition();
    }

    if (event.type == 'finished') {
      if (!didEndActivity) {
        activity.endActivity();
        didEndActivity = true;
      }
    }
  }

  function executeTracking() {
    var opts = {
      app: app,
      object: object,
      currentPosition: currentPosition,
      length: audioLength,
      startedPlayback: start
    };

    if (prevPosition != currentPosition) {
      var e = encodeURIComponent;
      $.get("hls-track?".concat(Object.keys(opts).map(function (v) {
        return "".concat(e(v), "=").concat(e(String(opts[v])));
      }).join('&')), function () {});
    }

    prevPosition = currentPosition;
    trackTimeout = null;
  }

  function doTrack() {
    if (trackTimeout) return;
    trackTimeout = setTimeout(executeTracking, 2000);
  }

  function updatePosition() {
    if (isNaN(serverPosition)) currentPosition = isNaN(clientPosition) ? 0 : clientPosition;else currentPosition = isNaN(clientPosition) ? serverPosition : Math.min(clientPosition, serverPosition);
    doTrack();
  }
}